<template>
    <div data-test="snippets-filter" class="col-span-12">
        <analytics-sidebar-box
            @reset="emit('reset')"
            :canReset="selectedSnippets.length > 0"
            :hasContent="selectedSnippets.length > 0"
        >
            <template v-slot:title> Locked Snippets </template>

            <div
                v-if="selectedSnippets.length"
                @click="emit('click')"
                class="group/selection cursor-pointer select-none relative text-xs flex flex-col gap-2"
            >
                <div
                    v-for="snippet in selectedSnippets"
                    :key="`select_snippet_${snippet.snippet_id}`"
                    class="flex items-baseline justify-start gap-2 pr-1 transition duration-300 group-hover/selection:opacity-5 group-hover/selection:blur-[1px]"
                >
                    <div class="min-w-0 grow break-words">
                        {{
                            ('snippet_name' in snippet ? snippet.snippet_name : '') ||
                            snippetName(snippet) ||
                            'Loading...'
                        }}
                    </div>
                    <font-awesome-icon
                        v-if="'deleted_at' in snippet && snippet.deleted_at"
                        widthAuto
                        :icon="faTrashCanXmark"
                        class="translate-y-0.5 text-sm"
                    ></font-awesome-icon>
                </div>

                <div
                    class="absolute inset-0 flex flex-wrap items-center justify-center gap-2 overflow-hidden text-xs font-bold opacity-0 transition group-hover/selection:opacity-100 group-hover/selection:delay-75"
                >
                    <div
                        class="absolute flex items-center justify-center gap-2 transition duration-300"
                        :class="[selectingSnippets ? 'opacity-100' : 'translate-y-12 opacity-0']"
                    >
                        Done
                        <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                    </div>
                    <div
                        class="absolute flex items-center justify-center gap-2 transition duration-300"
                        :class="[!selectingSnippets ? 'opacity-100' : '-translate-y-12 opacity-0']"
                    >
                        Manage Selection
                        <font-awesome-icon widthAuto :icon="faPencil"></font-awesome-icon>
                    </div>
                </div>
            </div>

            <template v-slot:actions>
                <button
                    @click="emit('click')"
                    :disabled="selectingResources"
                    data-test="handle-snippet-selection"
                    class="group/add-snippets -mt-3 -mx-3 -mb-3 flex w-[calc(100%+24px)] py-3 rounded-b-lg justify-center relative overflow-hidden items-center text-xs text-black bg-slate-200 border border-solid border-b-0 border-x-0 border-t-slate-300 font-semibold transition hover:bg-slate-300"
                    :class="{
                        'cursor-pointer': !selectingResources,
                        'opacity-50 cursor-not-allowed pointer-events-none': selectingResources,
                    }"
                >
                    <div
                        class="flex items-center gap-2 transition duration-300"
                        :class="{ 'group-hover/add-snippets:-translate-y-12': selectingSnippets }"
                    >
                        Add Snippets
                        <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                    </div>
                    <div
                        class="absolute inset-0 flex items-center justify-center gap-2 transition duration-300 translate-y-12"
                        :class="{ 'group-hover/add-snippets:translate-y-0': selectingSnippets }"
                    >
                        Done
                        <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                    </div>
                </button>
            </template>
        </analytics-sidebar-box>
    </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleCheck, faCirclePlus, faPencil } from '@fortawesome/pro-solid-svg-icons';
import { faTrashCanXmark } from '@fortawesome/pro-regular-svg-icons';
import AnalyticsSidebarBox from '~/components/analytics/partial/sidebar/AnalyticsSidebarBox.vue';
import { useAnalyticsSelectSnippets } from './useAnalyticsSelectSnippets';
import { useAnalyticsSelectResources } from '~/components/analytics/partial/select-resources/useAnalyticsSelectResources';

const { selectingSnippets, selectedSnippets, snippetName } = useAnalyticsSelectSnippets();
const { selectingResources } = useAnalyticsSelectResources();

const emit = defineEmits<{
    click: [];
    reset: [];
}>();
</script>
